/*
 * Generated on 10/24/2023, 4:05:29 PM
 * Do not edit this file, any changes will be overwritten
 */

"use strict";

function openPopup(pUrl, pWidth, pHeight) {
  if (!pWidth) pWidth = 800;
  if (!pHeight) pHeight = 600;
  var sWidth = screen.availWidth;
  var sHeight = screen.availHeight;
  var pTop = sHeight / 2 - pHeight / 2;
  var pLeft = sWidth / 2 - pWidth / 2;
  window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' + ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}

function openIframePopup(src) {
  var $modal = $('.popup-modal');
  var $iframe = $modal.find('iframe');
  src += src.indexOf('?') >= 0 ? '&' : '?';
  src += 'popup=1';
  $iframe.off('load').on('load', function () {
    var element = this;
    setTimeout(function () {
      var height = element.contentWindow.document.body.scrollHeight + 20;
      var maxHeight = $(window).height() - 80;
      var hasOverflow = false;

      if (height > maxHeight) {
        height = maxHeight;
        hasOverflow = true;
      }

      $iframe.animate({
        'height': height + 'px'
      }, 300, function () {
        $modal.removeClass('loading').toggleClass('has-overflow', hasOverflow);
        $iframe.removeClass('invisible');
        $iframe.contents().find('body').css({
          'height': '100%',
          'overflow': 'auto',
          '-webkit-overflow-scrolling': 'touch'
        });
      });
    }, 200);
  });
  $modal.modal('show');
  $modal.addClass('loading');
  $iframe.addClass('invisible').css({
    'height': '150px'
  }).attr('src', src);
}

function showAlert(alert, okText) {
  var $popin = $('.alert-popin');
  var $btn = $popin.find('.btn');

  if ($popin.is(':visible')) {
    return;
  }

  if (okText === undefined) {
    okText = $btn.data('text');
  }

  $btn.text(okText);
  $popin.find('.text').html(alert);
  $popin.modal({
    backdrop: 'static',
    keyboard: false
  });
}

function checkSidebarHeight() {
  $('.sidebar').each(function () {
    var sidebarHeight = $(this).outerHeight(true);
    var windowHeight = $(window).height();
    windowHeight -= $('.navbar-fixed-top').outerHeight();

    if (sidebarHeight > windowHeight) {
      $(this).addClass('no-affix');
    } else {
      $(this).removeClass('no-affix');
    }
  });
}

function htmlEncode(string) {
  string = $('<div>').text(string).html();
  string = string.replace('"', '&quot;');
  return string;
}

function printOnly($element) {
  $('body').addClass('print-nothing');
  $element.addClass('print');
  window.print();
  $element.removeClass('print');
  $('body').removeClass('print-nothing');
}

function isScrolledIntoView($element) {
  if ($element.length == 0 || !$element.is(':visible')) {
    return false;
  }

  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $element.offset().top;
  var elemBottom = elemTop + $element.height();
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

function openBackdrop(clickCallback) {
  var $backdrop = $('.backdrop');

  if ($backdrop.length === 0) {
    $backdrop = $('<div class="backdrop"></div>');
    $('body').append($backdrop);
  }

  if (!$backdrop.is(':visible')) {
    $backdrop.fadeIn();
  }

  if (typeof clickCallback == 'function') {
    $backdrop.on('click', clickCallback);
  }
}

function closeBackdrop() {
  var $backdrop = $('.backdrop');

  if ($backdrop.length > 0) {
    $backdrop.fadeOut();
    $backdrop.on('click', function () {});
  }
}

function getScrollbarWidth($element) {
  var remove = false;

  if (typeof $element === 'undefined') {
    remove = true;
    $element = $('<div style="height:1px;overflow-y:scroll;"/>');
    $element.appendTo('body');
  }

  var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
  if (remove) $element.remove();
  return scrollbarWidth;
}

function disableBodyScroll() {
  // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
  $('body').addClass('scroll-disabled').css({
    'padding-right': getScrollbarWidth() + 'px',
    'position': 'fixed',
    'top': -window.scrollY + 'px'
  });
  $('.navbar-fixed-top, .modal').css('margin-right', getScrollbarWidth() + 'px');
}

function enableBodyScroll() {
  var scrollY = document.body.style.top;
  $('body').css({
    'padding-right': '',
    'position': '',
    'top': ''
  }).removeClass('scroll-disabled').data('padding-right', '');
  $('.navbar-fixed-top, .modal').css('margin-right', '');
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

function smoothScrollTo($element, offset, duration) {
  if ($element.length === 0) return;

  if (duration === undefined) {
    duration = 1000;
  }

  $([document.documentElement, document.body]).stop(false, false).animate({
    scrollTop: $element.offset().top + (offset === undefined ? 0 : parseInt(offset))
  }, duration);
}

function smoothScrollToCenter($element, offset, duration) {
  if ($element.length === 0) return;
  offset -= $(window).height() / 2;
  smoothScrollTo($element, offset, duration);
}

function getElementsInViewport(selector) {
  var elements = [];
  $(selector).each(function () {
    var rect = this.getBoundingClientRect();

    if (rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth)) {
      elements.push($(this));
    }
  });
  return elements;
}

function showSplashBlock(type, initfunc) {
  $('.block-huisartsen, .block-spoedpost, .block-overig').addClass('d-none');
  $('.btn-huisartsen, .btn-spoedpost, .btn-overig').removeClass('active');
  $('.btn-' + type).addClass('active');
  $('.block-' + type).removeClass('d-none');
  $('.homepage-patienten').removeClass('bg-huisartsen bg-spoedpost bg-overig');
  $('.homepage-patienten').addClass('bg-' + type); // window.dispatchEvent(new Event('resize')); // is niet < IE11 compatible
  // $(window).trigger('resize'); // werkt het kaartje niet meer op andere tab
  // if (initfunc == 0 || initfunc == 1) {
  // 	initialize1();
  // }
  // if (initfunc == 0 || initfunc == 2) {
  // 	initialize2();
  // }
}

var Menu = function () {
  var currentScrollTop = 0;
  $(document).ready(function () {
    var scrollBarWidth = getScrollbarWidth(); // $('.navbar-toggle-btn, .has-dropdown').on('click', function(e) {
    // 	e.preventDefault();
    // });

    var $collapsable = $('.navbar-dropdown, .navbar-collapse, .navbar-search-collapse');
    $collapsable.on('show.bs.collapse', function (e) {
      $collapsable.not($(this)).collapse('hide');
      var $element = $(this);
      openBackdrop(function () {
        $element.collapse('hide');
      });
    }).on('hide.bs.collapse', function (e) {
      setTimeout(function () {
        if ($collapsable.filter('.collapsing').length <= 1) {
          closeBackdrop();
        }
      }, 1);
    }); //

    $('.dropdown').each(function () {
      var $dropdown = $(this);
      var $toggleMobile = $dropdown.find('.dropdown-toggler-mobile').first();
      var $menu = $dropdown.find('.dropdown-menu').first();

      if ($menu.length === 0) {
        return;
      }

      $dropdown.on('click', function (e) {
        var $clickElement = $(e.target);

        if ($clickElement.hasClass('.dropdown-toggler-mobile') || $clickElement.closest('.dropdown-toggler-mobile').length > 0) {
          e.preventDefault();
        }
      });
      $toggleMobile.on('click', function (e) {
        if ($dropdown.hasClass('dropdown-open')) {
          $dropdown.removeClass('dropdown-open');
          $menu.stop(false, false).slideUp();
        } else {
          $dropdown.addClass('dropdown-open');
          $menu.stop(false, false).slideDown();
        }
      });
    }); // Voor desktop alleen level 1 dropdown gebruiken

    $('.level-1 > .dropdown').each(function () {
      var $dropdown = $(this);
      var $toggleMobile = $dropdown.find('.dropdown-toggler-mobile').first();
      var $menu = $dropdown.find('.dropdown-menu').first();
      $dropdown.on('mouseenter', function (e) {
        if ($toggleMobile.is(':visible')) {
          return;
        } // Timeout toepassen om een eventuele click event eerst te kunnen behandelen


        setTimeout(function () {
          // Als de dropdown buiten het scherm dreigt te vallen, dan rechts uitlijnen
          if ($dropdown.offset().left + $menu.width() > $(window).width()) {
            $menu.addClass('align-right');
          } else {
            $menu.removeClass('align-right');
          }

          $menu.addClass('showing');
        }, 5);
      }).on('mouseleave', function (e) {
        if ($toggleMobile.is(':visible')) {
          return;
        }

        $menu.removeClass('showing');
      });
    });
    $('.navbar-search-collapse').on('show.bs.collapse', function (e) {
      var $element = $(this);
      setTimeout(function () {
        $element.find('.form-control').trigger('focus');
      }, 500);
    }); // Collapse menu

    $('.navbar-main-collapse').on('show.bs.collapse', function (e) {
      // $('.navbar-search').collapse('hide');
      $('.navbar-toggle-btn').addClass('active'); // $('body').addClass('scroll-disabled').css('margin-right', getScrollbarWidth());
      // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
      // scrolltop opslaan en de body overflow hidden geven.
      // setScrollTop();
      // setTimeout(function() {
      //     $('body').addClass('scroll-disabled');
      //     $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
      // }, 300);
    }).on('hide.bs.collapse', function (e) {
      $('.navbar-toggle-btn').removeClass('active'); // Bij het sluiten van het menu de body weer overflow scroll geven
      // en de opgeslagen scrolltop laden.
      // $('body').removeClass('scroll-disabled').css('margin-right', 0);
      // $('.navbar-fixed-top').css('margin-right', 0);
      // window.scrollTop = currentScrollTop;
    }); // Slide toggle submenu

    $('.navbar-main .has-submenu > a .item-open').on('click', function (e) {
      // if ($(window).width() > 991) {
      // 	return;
      // }
      // var $submenu = $(this).closest('li').find('.navbar-subnav');
      // if (!$submenu.is(':visible')) {
      // 	e.preventDefault();
      // 	$submenu.slideToggle('fast');
      // }
      var $item = $(this).closest('li');
      var $submenu = $item.find('> .navbar-subnav');
      e.preventDefault();

      if (!$submenu.is(':visible')) {
        $item.addClass('submenu-open');
        $submenu.slideDown('fast');
      } else {
        $item.removeClass('submenu-open');
        $submenu.slideUp('fast');
      }
    }); // If a main menu link was clicked and the available submenu is not visible, show the submenu and stop navigation.

    $('.navbar-main .has-submenu > a').on('click', function (e) {
      var $submenu = $(this).parent().find('.navbar-subnav');

      if (!$submenu.is(':visible') || $submenu.height() == 0) {
        e.preventDefault();
        $submenu.slideDown('fast');
        $(this).find('i').removeClass('fa-chevron-down');
        $(this).find('i').addClass('fa-chevron-up');
      }
    });
    $('.navbar-main .submenu-collapse').on('click', function (e) {
      var $submenu = $(this).parent().parent().parent().find('.navbar-subnav');

      if (!$submenu.is(':visible') || $submenu.height() > 0) {
        e.preventDefault();
        $submenu.slideUp('fast');
        $(this).find('i').removeClass('fa-chevron-up');
        $(this).find('i').addClass('fa-chevron-down');
      }
    }); // Navbar search

    $('.open-navbar-search').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.navbar-search').addClass('focus').find('input').focus();
    });
    $(document).on('click', function () {
      $('.navbar-search').removeClass('focus');
      $('.navbar-dropdown.in').collapse('hide');
      $('.navbar-search').collapse('hide');
    });
    $('.navbar-search').on('click', function (e) {
      e.stopPropagation();
    }); // Collapse search
    // $('.navbar-search').on('show.bs.collapse', function() {
    //     $('.navbar-custom-collapse').collapse('hide');
    //     $('.navbar-search-toggle').addClass('active');
    //
    //     setTimeout(function() {
    //         $('.navbar-search .form-control').focus();
    //     }, 500);
    // });
    // $('.navbar-search').on('hide.bs.collapse', function() {
    //     $('.navbar-search-toggle').removeClass('active');
    //     $('body').removeClass('scroll-disabled');
    //     window.scrollTop = currentScrollTop;
    // });
    // Popin dropdown menus

    $('a[data-target-popin-menu]').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return;
      }

      var showContainer = $(this).data('target-popin-menu');
      $('.nav-popin-menu').not(showContainer).removeClass('active');

      if ($(showContainer).hasClass('active')) {
        $(showContainer).removeClass('active');
      } else {
        $(showContainer).addClass('active');
        $(window).trigger('resize-popin-menu');
      }
    });
    $(document).on('click', function (e) {
      $('.nav-popin-menu').removeClass('active');
    });
    $('.nav-popin-menu').on('click', function (e) {// e.stopPropagation();
    }); // $(window).on('resize resize-popin-menu', function() {
    //     $('a[data-target-popin-menu]').each(function() {
    //         var $target = $($(this).data('target-popin-menu'));
    //
    //         if (!$target.hasClass('active')) {
    //             return;
    //         }
    //
    //         if ($(window).width() < 768) {
    // 			$target.css({
    // 				'right': 0,
    // 				'left': 'auto'
    // 			});
    //
    //         } else {
    // 			$target.css({
    // 				'left': 0,
    // 				'right': 'auto'
    // 			});
    // 		}
    //
    //         $target.css('top', $(this).position().top + $(this).height());
    //     });
    // });
  });
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      $('.navbar-dropdown.show').collapse('hide');
      $('.navbar-search').removeClass('focus');
    }
  });

  var setScrollTop = function setScrollTop() {
    currentScrollTop = window.scrollTop;
  };

  var getScrollbarWidth = function getScrollbarWidth() {
    var $div = $('<div />').css({
      width: '100px',
      height: '100px',
      overflow: 'scroll',
      position: 'absolute',
      top: '-9999px'
    }).appendTo($('body'));
    var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
    $div.remove();
    return scrollbarWidth;
  };

  return this;
}();

$(function () {
  $(window).on('resize', function () {
    if ($(document).width() < 976) {
      $('.navbar-dropdown').addClass('mobile-dropdown');
    } else {
      $('.navbar-dropdown').removeClass('mobile-dropdown');
    }

    $('.has-submenu .navbar-subnav').show();
    $('.mobile-dropdown .has-submenu .navbar-subnav').hide();
    $('.mobile-dropdown .has-submenu.active .navbar-subnav').show();
  }).trigger('resize');
  $('.item-open').on('click', function () {
    var $chevron = $(this).find('i');
    var $submenu = $(this).parents('.has-submenu').find('ul.navbar-subnav');

    if (!$submenu.is(':visible')) {
      $chevron.removeClass('fa-chevron-down').addClass('fa-chevron-up');
      $submenu.slideDown('fast');
    } else {
      $chevron.removeClass('fa-chevron-up').addClass('fa-chevron-down');
      $submenu.slideUp('fast');
    }
  });
});
$(function () {
  // checkCustomInputs();
  $('[data-background], img[data-src]').imageLoader(); // Open popup links inside a modal

  $(document).on('click', 'a.popup', function (e) {
    e.preventDefault();
    window.top.openIframePopup($(this).attr('href'));
  }); // Make sure internal links inside popups are opened correctly

  $('body.popup .text a[href^="/"]').addClass('popup'); // Make sure external links inside popups are opened in a new window

  $('body.popup a[href^="http"]').attr('target', '_blank');
  $('body').tooltip({
    selector: '[data-bs-toggle="tooltip"]',
    offset: "0, 5",
    delay: 300
  }); // flags bij messages uitklappen:
  // $('a.actions-selected').click(function() {
  //
  // 	$('.message-flags').fadeOut(200);
  //
  // 	var showContainer = $(this).data('container');
  //
  // 	console.log(showContainer);
  //
  //     if ($('.'+showContainer+'').is(':visible')) {
  //         $('.'+showContainer).hide();
  //     } else {
  //         $('.'+showContainer).show();
  //     }
  //
  //     return false;
  // });
  //
  // // fade out van flags bij messages
  // $('.message-flags').hover(
  // 	function(){},
  // 	function(){
  // 		$(this).fadeOut(200);
  // 	}
  // );

  $(document).on('click', 'a.confirm', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $popin = $('#confirm-modal');
    var textYes = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
    var textNo = $(this).data('text-no') || $popin.find('.no').data('text-no');
    var onConfirm = $(this).data('onconfirm') || '';

    if ($popin.is(':visible')) {
      return;
    }

    $popin.find('.text').html($(this).data('confirm'));
    $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
    $popin.find('.no').text(textNo);
    $popin.modal('show');

    if (onConfirm) {
      $popin.find('.yes').attr('onclick', onConfirm);
    }
  });
  $(document).on('click', 'a.show-alert', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $popin = $('#alert-modal');

    if ($popin.is(':visible')) {
      return;
    }

    $popin.find('.text').html($(this).data('alert'));
    $popin.modal('show');
  });
  $('input[type=number]').on('input', function () {
    var min = parseInt($(this).attr('min'));
    var max = parseInt($(this).attr('max'));
    var maxLength = parseInt($(this).attr('maxlength'));
    var value = parseInt($(this).val());

    if (!isNaN(max) && value > max) {
      $(this).val(max);
    }

    if (!isNaN(min) && value < min) {
      $(this).val(min);
    }

    if (!isNaN(maxLength)) {
      $(this).val($(this).val().substring(0, maxLength));
    }
  });
  $(document).on('click', '.btn', function (e) {
    var $btn = $(this);
    $btn.addClass('clicked');
    setTimeout(function () {
      $btn.removeClass('clicked');
    }, 100);
  });
  $('.toggle-pass').on('mousedown', function (e) {
    e.preventDefault();
    var $passField = $(this).parent().find('input');
    var $icon = $(this).find('i');
    var newType = $passField.attr('type') === 'text' ? 'password' : 'text';
    $passField.attr('type', newType).focus();
    newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
  }).on('click', function (e) {
    e.preventDefault();
  });
  $('.modal').on('show.bs.modal', function (e) {
    $('body').addClass('modal-active');
  }).on('hide.bs.modal', function (e) {
    $('body').removeClass('modal-active');
  }).on('shown.bs.modal', function () {
    $('[data-bs-toggle="tooltip"]').tooltip('hide');
  });
  $('select').on('change empty-init', function () {
    $(this).toggleClass('empty', $(this).val() === '');
  }).trigger('empty-init');
});
$(window).on('resize resize-init', function () {
  checkSidebarHeight();
  document.documentElement.style.setProperty('--vh', "".concat(window.innerHeight, "px"));
}).trigger('resize-init');
$(window).on('scroll', function () {
  var scrollTop = $(this).scrollTop();

  if (scrollTop > 0) {
    $('body').addClass('scrolled');
  } else {
    $('body').removeClass('scrolled');
  }
}).trigger('scroll');
var dateTimePickerIcons = {
  time: 'fa fa-clock',
  date: 'fa fa-calendar',
  up: 'fa fa-chevron-up',
  down: 'fa fa-chevron-down',
  previous: 'fa fa-chevron-double-left',
  next: 'fa fa-chevron-double-right',
  today: 'fa fa-crosshairs',
  clear: 'fa fa-trash',
  close: 'fa fa-times'
};
$(window).on('mousewheel', function () {
  $(window).trigger('scroll');
});
setInterval(function () {
  $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
$(function () {
  checkInputErrors();
  $('form').not('.debug, .novalidate').attr('novalidate', 'novalidate').on('submit fake-submit', function (e) {
    var $form = $(this);
    var $submit = $form.find('[type=submit]');
    var errorItems = [];
    var loadingMax = $(this).data('loading-max') || 5;
    $form.removeClass('has-errors');

    if (e.type === 'submit' && !$form.hasClass('no-loader')) {
      $submit.prop('disabled', true).addClass('loading');
    }

    $form.find('.form-required .input-error[data-error-default!=""]').each(function () {
      var $item = $(this);
      var fields = $(this).data('error-fields').split(',');
      $.each(fields, function (key, value) {
        var $field = $form.find('[name="' + value + '"], [name^="' + value + '["], [name^="form_fields[' + value + ']"]');

        if ($field.length === 0) {
          console.warn('Could not find field with name', value);
          return;
        }

        var type = $field.get(0).type;

        if (!$field.is(':visible')) {
          // Niet valideren als het veld niet eens zichtbaar is
          // Let op: Dit is een aanpassing die ook een update van custom-inputs.less vereist!
          return;
        }

        if ($form.hasClass('debug')) {
          return; // in debug mode niks client-side valideren
        } // Default checks


        switch (type) {
          default:
            if ($field.val() === '') {
              errorItems.push($item);
              return;
            }

            break;

          case 'checkbox':
          case 'radio':
            if ($field.filter(':checked').length === 0) {
              errorItems.push($item);
              return;
            }

        } // Additional checks


        if (type === 'email') {
          if (!/^.+@.+\..+$/.test($field.val())) {
            errorItems.push($item);
          }
        } // No errors found, remove the error


        $item.text('');
      });
    });

    if (errorItems.length > 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $form.addClass('has-errors');
      $.each(errorItems, function (key, $errorItem) {
        $errorItem.html($(this).data('error-default'));
      });
      $submit.removeClass('loading');
      setTimeout(function () {
        $submit.prop('disabled', false);
      }, 2000);
    } else {
      setTimeout(function () {
        $submit.prop('disabled', false);
      }, loadingMax * 1000);
    }

    checkInputErrors();
  });
});

function checkInputErrors() {
  var $allErrors = $('.input-errors-all');
  var $errorForm = false;
  $('.input-error').each(function () {
    var field = $(this).attr('data-error-name');
    var $group = $(this).closest('.form-group');

    if ($(this).text().trim() !== '') {
      $errorForm = $(this).closest('form');
      $allErrors.find('[data-error-name="' + field + '"]').remove(); // Hide error in form top error listing

      $group.addClass('form-error');
      $(this).removeClass('d-none');
    } else {
      $group.removeClass('form-error');
      $(this).addClass('d-none');
    }
  });

  if ($allErrors.text().trim() === '') {
    $allErrors.hide();
  } else {
    $allErrors.slideDown('fast');
    $errorForm = $allErrors.closest('form');
  }

  var $firstError = $('.input-error:not(.d-none):first');

  if ($errorForm) {
    // If the error is in a modal, open the modal
    if ($errorForm.closest('.modal').length > 0) {
      $errorForm.closest('.modal').modal();
    } else {
      var $element = $firstError.closest('.form-group');

      if ($element.length === 0) {
        $element = $firstError;
      }

      setTimeout(function () {
        smoothScrollToCenter($element, $element.outerHeight() / 2, 500);
      }, 500);
    }
  }
}

$(function () {
  $(document).on('mouseenter', '.rating-wrapper .rating-star', function () {
    if ($(this).hasClass('disabled')) return;
    $(this).addClass('hover hover-current').prevAll().addClass('hover');
    $(this).parent().find('.rating-total').text($(this).data('rating'));
  });
  $(document).on('mouseleave', '.rating-wrapper .rating-star', function () {
    if ($(this).hasClass('disabled')) return;
    $(this).removeClass('hover hover-current').prevAll().removeClass('hover');
    $(this).parent().find('.rating-total').text($(this).parent().find('input').val());
  });
  $(document).on('click init.rating', '.rating-wrapper .rating-star', function (e) {
    if (e.type !== 'init' && $(this).hasClass('disabled')) return;
    $(this).siblings().removeClass('active active-current');
    $(this).addClass('active active-current').prevAll().addClass('active');
    $(this).parent().find('input').val($(this).data('rating'));
    $(this).parent().find('.rating-total').text($(this).data('rating'));
  });
  $('.rating').each(function () {
    var $input = $(this);
    var $wrapper = $('<div class="rating-wrapper form-control-static" />');
    var max = $input.attr('max') || 5;
    var disabled = $input.prop('disabled');
    $wrapper.insertAfter($input);
    $input.appendTo($wrapper).addClass('d-none');

    for (var i = 1; i <= max; i++) {
      $wrapper.append('<span class="rating-star ' + (disabled ? 'disabled' : '') + '" data-rating="' + i + '" />');
    }

    $wrapper.append('<span class="rating-total" />');
    $wrapper.find('[data-rating="' + $input.val() + '"]').trigger('init.rating');
  });
});

var CustomMap = function CustomMap(options) {
  var self = this;
  this.options = $.extend({
    container: $('#map'),
    zoom: 12,
    backgroundColor: '#ffffff',
    minZoom: 5,
    maxZoom: 17,
    zoomInterval: 1200,
    mapTypeControl: false,
    scrollwheel: false,
    streetViewControl: false
  }, options);
  this.map = false;
  this.currentCenter = this.options.center;
  this.zoomFluid = 0;
  this.markers = [];
  this.markerOptions = {};
  google.maps.event.addDomListener(window, 'load', function () {
    self.init();
  });
};

CustomMap.prototype.init = function () {
  var self = this;
  this.map = new google.maps.Map(this.options.container.get(0), this.options); // Keep the map centered while resizing the window

  google.maps.event.addDomListener(window, 'resize', function () {
    setTimeout(function () {
      self.map.setCenter(self.currentCenter);
    }, 300);
  });
  this.map.addListener('dragend', function () {
    self.currentCenter = self.map.getCenter();
  });
  google.maps.event.addListenerOnce(this.map, 'idle', function () {
    self.currentCenter = self.map.getCenter();
  });

  if (typeof this.options.onInit == 'function') {
    this.options.onInit(this);
  }
};

CustomMap.prototype.reload = function () {
  var self = this;
  setTimeout(function () {
    google.maps.event.trigger(self.map, 'resize');
    self.fitBounds();
  }, 300);
};

CustomMap.prototype.loadMarkers = function (markers, options) {
  var self = this;
  this.markerOptions = $.extend({
    image: false,
    onClick: false
  }, options);

  if (this.markerOptions.image != false) {
    var image = new google.maps.MarkerImage(this.markerOptions.image);
  }

  for (var i = 0; i < markers.length; i++) {
    var markerData = markers[i];

    if (markerData.latLng[0] == 0) {
      continue;
    }

    var marker = new google.maps.Marker({
      map: this.map,
      icon: image,
      draggable: false,
      position: new google.maps.LatLng(markerData.latLng[0], markerData.latLng[1]),
      visible: true,
      markerData: markerData
    });
    this.markers.push(marker);

    if (typeof this.markerOptions.onClick == 'function') {
      google.maps.event.addListener(marker, 'click', function (marker) {
        return function () {
          self.markerOptions.onClick(marker);
        };
      }(marker));
    }
  }
};

CustomMap.prototype.clearMarkers = function () {
  for (var i = 0; i < this.markers.length; i++) {
    this.markers[i].setMap(null);
  }

  this.markers = [];
};

CustomMap.prototype.fitBounds = function () {
  if (this.markers.length === 0) {
    return;
  }

  var bounds = new google.maps.LatLngBounds();

  for (var i = 0; i < this.markers.length; i++) {
    bounds.extend(this.markers[i].getPosition());
  }

  if (typeof this.map.fitBounds == 'function') {
    this.map.fitBounds(bounds);
  }
};

CustomMap.prototype.initSearchForm = function (formSelector, resultsSelector, searchUrl, onLoad) {
  $(formSelector).on('submit init-searchform', function (e) {
    e.preventDefault();
    console.log('submit');
    var args = $(this).serialize();
    $(resultsSelector).stop(false, false).slideUp('fast', function () {
      var $block = $(this);
      $block.html('');
      $.getJSON('/site/ajax/search_locations.php', args, function (data) {
        var prevId = 0;
        var resultIds = [];
        var count = 1;

        for (var key in data.items) {
          var item = data.items[key];
          var id = item.id;
          var $element = $(item.html);
          resultIds.push(id);

          if ($(resultsSelector + ' > div[data-item_id=' + id + ']').length > 0) {
            continue;
          }

          if (prevId == 0) {
            $element.prependTo(resultsSelector);
          } else {
            $element.insertAfter(resultsSelector + ' > div[data-item_id=' + prevId + ']');
          }

          $element.hide();
          prevId = id;
          $element.slideDown();
          count++;
        } // $(resultsSelector + ' > div').each(function() {
        // 	var itemId = $(this).attr('data-item_id');
        // if ($.inArray(itemId, resultIds) < 0) {
        // 	$(this).slideUp('fast', function() {
        // 		$(this).remove();
        // 	});
        // }
        // });


        $block.slideDown('fast');
        $(resultsSelector).slideDown('fast');

        if (typeof onLoad == 'function') {
          onLoad(data);
        }
      });
    });
  }); //.trigger('init-searchform');
};